"use client";

import { Button } from "@/components/ui/button";

interface AnalysisButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  mode?: "marketing" | "app";
}

export function AnalysisButton({
  onClick,
  disabled = false,
  isLoading = false,
  className = "",
  mode = "marketing",
}: AnalysisButtonProps) {
  const heightClasses =
    mode === "app" ? "h-10 sm:h-[3.25rem]" : "h-10 sm:h-12 md:h-14";

  return (
    <Button
      type="button"
      onClick={onClick}
      className={`${heightClasses} w-full sm:w-auto px-6 text-sm sm:text-base bg-primary hover:bg-primary/90 font-medium ${className}`}
      disabled={disabled || isLoading}
    >
      {isLoading ? "Analyzing..." : "Analyze"}
    </Button>
  );
}
